import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../constants/path';

import { scrollToAnchor } from '../../utils';
import { convertHtmlToReactDomWithParams } from '../../utils/htmlUtils';

import { HeadComponent } from '../HeadComponent';
import { withTemplate } from '../template/withTemplate';
import { PrimaryTemplate } from '../template/PrimaryTemplate';
import LocalizedBreadcrumbItem from '../breadcrumb/LocalizedBreadcrumbsItem';

import './LegalNoticePage.scss';

class LegalNoticePage extends React.Component {
    componentDidMount() {
        scrollToAnchor(this.props.location);
    }

    componentDidUpdate() {
        scrollToAnchor(this.props.location);
    }

    render() {
        const { i18n } = this.props;
        return (
            <main className="conteneur conteneur-mobile" id="p-mentionslegales">
                <HeadComponent title={i18n.TITLE} description={i18n.DESCRIPTION} />
                <LocalizedBreadcrumbItem to={PATH.LEGAL_NOTICE_PATH}>
                    {i18n.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <h1>{i18n.TITLE}</h1>

                <h3>{i18n.TITLE1}</h3>
                <p>{i18n.TEXT1_1}</p>
                <p>{i18n.TEXT1_4}</p>

                <h3>{i18n.TITLE2}</h3>
                <p>
                    {i18n.TEXT2_1}
                    <br />
                    {i18n.TEXT2_2}
                </p>

                <h3>{i18n.TITLE3}</h3>
                <p>{i18n.TEXT3_1}</p>

                <h3>{i18n.TITLE4}</h3>
                <p>{i18n.TEXT4_1}</p>
                <p>
                    {i18n.TEXT4_2}
                    <br />
                    {i18n.TEXT4_3}
                </p>

                <h3>{i18n.TITLE5}</h3>
                <p>{i18n.TEXT5_1}</p>
                <p>{i18n.TEXT5_2}</p>
                <p>{i18n.TEXT5_3}</p>
                <p>{i18n.TEXT5_4}</p>
                <p>{i18n.TEXT5_5}</p>

                <h3>{i18n.TITLE6}</h3>
                <p>{i18n.TEXT6_1}</p>
                <p>{i18n.TEXT6_2}</p>

                <h3>{i18n.TITLE7}</h3>
                <p>
                    {convertHtmlToReactDomWithParams(
                        i18n.TEXT7_1,
                        `${PATH.TERMS_PATH}#personal-data`
                    )}
                </p>
                <p />
            </main>
        );
    }
}

LegalNoticePage.propTypes = {
    i18n: PropTypes.object.isRequired
};

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    return {
        i18n: state.i18n.page.LEGAL_NOTICE
    };
}

export default withTemplate(connect(mapStateToProps)(LegalNoticePage), PrimaryTemplate);



// WEBPACK FOOTER //
// ./src/components/pages/LegalNoticePage.js